import { mdiInformationSlabCircleOutline } from '@mdi/js';
import HBox from '../layout/HBox';
import { Tooltip } from '../layout/Tooltip';
import styles from './CampoTexto.module.css';
import Icon from '@mdi/react';
import React from 'react';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  tooltipText?: React.ReactNode;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  noBorder?: boolean;
  rows?: number;
  [key: string]: any;
};

const CampoMemo = React.forwardRef<HTMLTextAreaElement, Props>(function CampoMemo(
  {
    value,
    onChange,
    label,
    placeholder,
    required,
    error,
    hint,
    tooltipText,
    tooltipPosition,
    noBorder,
    rows,
    ...props
  },
  ref
) {
  return (
    <div style={{ width: '100%' }}>
      {label && (
        <label className={styles.label}>
          <HBox stretch>
            <span>{label}</span>
            {tooltipText && (
              <Tooltip text={tooltipText} position={tooltipPosition}>
                <Icon
                  path={mdiInformationSlabCircleOutline}
                  size="14px"
                  color="var(--tc-color-info)"
                />
              </Tooltip>
            )}
          </HBox>
        </label>
      )}
      <textarea
        ref={ref}
        {...props}
        className={[styles.container, error ? styles.error : null].join(' ')}
        style={{
          padding: '9px 12px',
          width: '100%',
          border: noBorder ? 'none' : undefined,
        }}
        rows={rows}
        value={value}
        onChange={e => onChange?.(e.target.value)}
        placeholder={placeholder}
        required={required}
      />
      {hint && !error && <div className={styles.hint}>{hint}</div>}
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
});

export default CampoMemo;
